import { computed, ref } from "vue";

export const collapsed = ref(true);
export const collapsedIconVisibility = ref(true);

export const toggleSidebar = () => (collapsed.value = !collapsed.value);
export const closeSidebar = () => (collapsed.value = true);
export const toggleCollapsedIconVisibility = (status: boolean) => (collapsedIconVisibility.value = status);

export const SIDEBAR_WIDTH = 220;
export const SIDEBAR_WIDTH_COLLAPSED = 70;
export const sidebarWidth = computed(() => `${collapsed.value ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH}px`);
